<template>
    <div
        v-b-tooltip.hover
        class="delayed-slide-alert"
        :title="$translate(`${delayTimeInfo}`)"
        placement="leftbottom"
    >
        <img :src="iconPath" class="tli-chloe-cloak" alt="Tli And Chloe Time Difference" />
    </div>
</template>

<script>
import {
    MINIMUM_MINUTES_DELAY_FOR_DELAYED_SLIDE,
    TLI_CHLOE_TIME_DIFFERENCE_ICONS_PATH,
    TREATMENT_STATUS
} from '../../../business/const'
import { mapState } from 'vuex'
import moment from 'moment/moment'

export default {
    name: 'DelayedSlideAlert',
    computed: {
        ...mapState({
            selectedTreatment: state => state.timelapse.selectedTreatment
        }),
        delayedSlideMinutes() {
            if (this.selectedTreatment.status === TREATMENT_STATUS.INACTIVE) return null
            const delayedTime = this.selectedTreatment.slides.map(slide => {
                if (
                    slide.fertilizationDate &&
                    slide.hoursSinceFertilization &&
                    moment.invalid(slide.fertilizationDate)
                ) {
                    return Math.abs(
                        moment(slide.fertilizationDate)
                            .add(+slide.hoursSinceFertilization, 'hours')
                            .diff(moment().utc(), 'minutes')
                    )
                }
                return 0
            })
            return delayedTime.find(x => !!x && x > MINIMUM_MINUTES_DELAY_FOR_DELAYED_SLIDE)
        },
        delayTimeInfo() {
            const delayedMinutes = this.delayedSlideMinutes
            if (delayedMinutes >= 60) return 'red_cloak'
            if (delayedMinutes >= 30) return 'yellow_cloak'
            return 'grey_cloak'
        },
        iconPath() {
            return `${TLI_CHLOE_TIME_DIFFERENCE_ICONS_PATH}/${this.delayTimeInfo}.svg`
        }
    }
}
</script>

<style lang="scss" scoped>
.delayed-slide-alert {
    padding: 0 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;

    .tli-chloe-cloak {
        height: 1.5rem;
        width: 2rem;
    }
}
</style>
